import { gql } from "@apollo/client";

export const GET_DOCUMENTOS_SAP = gql`
query documentosSap(
    $idEstado: Int!
    $numeroDoc: String
    $fechaDesde: CustomDateTime
    $fechaHasta: CustomDateTime
) {
    documentosSap(idEstado: $idEstado, numeroDoc: $numeroDoc, fechaDesde: $fechaDesde, fechaHasta: $fechaHasta) {
        seEjecutoNormalmente
        valorEsperado{
            numeroPedido
            numeroDocumento
            factura
            remito
            minuta
            numeroDocLegal
            enviado
            message
            fecha
            hora
        }
        mensajeError
    }
}`;
